import { resetValidation } from './formModal';

const body = document.querySelector('body');

export const initializeModal = (dialog, modal, closeButton, form = null) => {
  let isModalOpen = false;

  const handleOutsideClick = e => {
    if (isModalOpen && !modal.contains(e.target)) {
      closeModal();
    }
  };

  const addEventListeners = () => {
    document.addEventListener('click', handleOutsideClick);
    document.addEventListener('keydown', handleEscapeKey);
    closeButton.addEventListener('click', closeModal);
  };

  const removeEventListeners = () => {
    document.removeEventListener('click', handleOutsideClick);
    document.addEventListener('keydown', handleEscapeKey);
    closeButton.removeEventListener('click', closeModal);
  };

  const handleEscapeKey = e => {
    if (isModalOpen && e.key === 'Escape') {
      closeModal();
    }
  };

  const openModal = e => {
    if (e) e.stopPropagation();

    dialog.showModal();
    body.classList.add('modal-open');
    isModalOpen = true;
    addEventListeners();
  };

  const closeModal = () => {
    dialog.close();
    body.classList.remove('modal-open');
    isModalOpen = false;
    removeEventListeners();
    resetValidation();

    if (form) form.reset();
  };

  return { openModal, closeModal };
};
